import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export function withUrlInterceptor(serverApiUrl: string): HttpInterceptorFn {
  return (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    if (req.url.startsWith('assets') || req.url.startsWith('./') || req.url.startsWith('../')) return next(req);

    const apiReq = req.url.startsWith('http')
      ? req.clone({ url: req.url })
      : req.clone({ url: `${serverApiUrl}${req.url}` });

    return next(apiReq);
  };
}
